export default __webpack_public_path__ + "static/media/share.afaba961.svg";